import { TFunction } from 'next-i18next';
import { useMemo } from 'react';
import { $enum } from 'ts-enum-util';
import { StudentExpireBookingReason } from '~graphql/__generated__/globalTypes';
import { notEmpty } from '~utils/js-helper';

type RoomAllocation = {
  bedId: string | null;
  bedName: string | null;
  flatName: string | null;
  roomName: string | null;
  floorName: string | null;
  buildingName: string | null;
};

export const useBookingRoomAllocationDetails = (
  roomAllocation: RoomAllocation | null | undefined
) => {
  return useMemo(() => {
    if (!roomAllocation) return;
    return [
      roomAllocation?.bedName,
      roomAllocation?.buildingName,
      roomAllocation?.flatName,
      roomAllocation?.floorName,
    ]
      .filter(notEmpty)
      .join(', ');
  }, [roomAllocation]);
};

export const useBookingInfoDetails = (params: {
  roomAllocation?: RoomAllocation | null | undefined;
  propertyName: string | null | undefined;
  cityName: string | null | undefined;
  isPropertyInfo?: boolean;
}) => {
  return useMemo(() => {
    const { roomAllocation, propertyName, cityName, isPropertyInfo = false } = params;

    const propertyInfo = `${propertyName} in ${cityName}`;

    if (isPropertyInfo) return propertyInfo;

    return [
      roomAllocation?.bedName,
      roomAllocation?.buildingName,
      roomAllocation?.flatName,
      propertyInfo,
    ]
      .filter(notEmpty)
      .join(', ');
  }, [params]);
};

export const useGetRejectOptiosn = (t: TFunction) => {
  return useMemo(() => {
    let deleteOptions = $enum(StudentExpireBookingReason).map(item => {
      return {
        label: t(`delete.reason.${item.toLowerCase()}`),
        value: item,
      };
    });
    const deleteIndex = deleteOptions.findIndex(item => {
      return item.value === StudentExpireBookingReason.FAILED_TO_ACCEPT_AMENDMENT;
    });
    deleteOptions.splice(deleteIndex, 1);
    return deleteOptions;
  }, [t]);
};

export const useIsNotPayToPartnerOrIsRollingBooking = (
  isPayToPartner: boolean,
  isRollingBooking: boolean
) => {
  return useMemo(() => {
    return !isPayToPartner && !isRollingBooking;
  }, [isPayToPartner, isRollingBooking]);
};
